import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Card,
  Typography,
  Stack,
  Chip,
  Grid,
  Button,
  TextField,
  MenuItem,
  Divider,
  Autocomplete
} from '@mui/material';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';
import { formatCurrencyBRL } from '../../../../@core/utils/utilsFunctions';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import configAxios from '../../../../services/configAxios';
import Iconify from '../../../../@core/theme/Iconify';
import RenderPage from '../../../layouts/RenderPage';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import Scrollbar from '../../../components/multiplesComponents/Scrollbar';
import Sortable from 'devextreme-react/sortable';
import AddEditLead from './addEditLead';

function tempoNaEtapa(data) {
  if (!data) {
    return '-';
  }
  const seconds = Math.max(0, Math.floor((Date.now() - new Date(data).getTime()) / 1000));
  if (seconds >= 86400) {
    return `${Math.floor(seconds / 86400)}d na etapa`;
  }
  if (seconds >= 3600) {
    return `${Math.floor(seconds / 3600)}h na etapa`;
  }
  if (seconds >= 60) {
    return `${Math.floor(seconds / 60)}min na etapa`;
  }
  return `${seconds}s na etapa`;
}

const getDefaultFilter = (isBroker, id_broker) => ({
  q: '',
  id_user: '',
  id_broker: isBroker ? id_broker : '',
  id_acquisition: '',
  temperatura: '',
  data_de: '',
  data_ate: ''
});

const LeadsKanban = (props) => {
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const isBroker = infoState.id_type_user === 2;
  const canSelectVend = !isBroker || infoState.id_profile === 1 || infoState.id_profile === 2;
  const [loading, setLoading] = useState(false);
  const [statuses, setStatuses] = useState([]);
  const [columns, setColumns] = useState({});
  const [infosBroker, setInfosBroker] = useState([]);
  const [infosVend, setInfosVend] = useState([]);
  const [acquisitions, setAcquisitions] = useState([]);
  const [filters, setFilters] = useState(getDefaultFilter(isBroker, infoState.id_broker));
  const [openModal, setOpenModal] = useState(false);
  const [infosItemEdit, setInfosItemEdit] = useState({});
  const draggingRef = useRef(false);

  useEffect(() => {
    getStatusLeads();
    getAcquisitions();
    if (isBroker) {
      loadVendors(infoState.id_broker);
    } else {
      getBrokers();
    }
  }, []);

  function getStatusLeads() {
    configAxios
      .get('/leads/getStatusLeads')
      .then((response) => {
        const list = response.data || [];
        setStatuses(list);
        getKanban(withScope(filters), list);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os status, tente novamente!',
          'Atenção'
        );
      });
  }

  function getBrokers() {
    configAxios
      .post('/brokers/listBrokerLabelUsers')
      .then((response) =>
        setInfosBroker((response.data || []).filter((item) => item.id !== '' && item.id != null))
      )
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as corretoras, tente novamente!',
          'Atenção'
        );
      });
  }

  function loadVendors(id_broker) {
    if (!id_broker) {
      setInfosVend([]);
      return;
    }
    configAxios
      .get(`/brokers/listVendLabel/${id_broker}`)
      .then((response) =>
        setInfosVend((response.data || []).filter((item) => item.id !== '' && item.id != null))
      )
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os vendedores, tente novamente!',
          'Atenção'
        );
      });
  }

  function withScope(next) {
    const params = { ...next };
    if (isBroker) {
      if (canSelectVend) {
        params.id_broker = infoState.id_broker;
      } else {
        params.id_broker = '';
        params.id_user = infoState.id;
      }
    }
    return params;
  }

  function getAcquisitions() {
    configAxios
      .get('/leads/getAcquisitionsAdmin')
      .then((response) => {
        setAcquisitions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os canais, tente novamente!',
          'Atenção'
        );
      });
  }

  function buildQuery(next = filters) {
    const params = new URLSearchParams();
    Object.keys(next).forEach((key) => {
      if (next[key] !== undefined && next[key] !== null && next[key] !== '') {
        params.append(key, next[key]);
      }
    });
    const q = params.toString();
    return q ? `?${q}` : '';
  }

  function getKanban(nextFilters = withScope(filters), statusList = statuses) {
    setLoading(true);
    configAxios
      .get(`/leads/getKanban${buildQuery(nextFilters)}`)
      .then((response) => {
        const rows = Array.isArray(response.data) ? response.data : [];
        const grouped = {};
        (statusList || []).forEach((s) => {
          grouped[s.id_status_lead] = [];
        });
        rows.forEach((item) => {
          const key = item.id_status_lead;
          if (!grouped[key]) {
            grouped[key] = [];
          }
          grouped[key].push(item);
        });
        setColumns(grouped);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar o kanban, por favor, tente novamente!',
          'Atenção'
        );
      })
      .finally(() => setLoading(false));
  }

  function getLead(id) {
    configAxios
      .get(`/leads/getLead/${id}`)
      .then((response) => {
        const data = response.data || {};
        const tags = typeof data.tags === 'string' ? JSON.parse(data.tags) : data.tags || [];
        setInfosItemEdit({ ...data, tags: Array.isArray(tags) ? tags : [] });
        setOpenModal(true);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar o lead, tente novamente!',
          'Atenção'
        );
      });
  }

  function moveLeadStatus(id_lead, id_status_lead) {
    let fromKey = null;
    let card = null;
    Object.keys(columns).forEach((key) => {
      const found = (columns[key] || []).find((item) => Number(item.id_lead) === Number(id_lead));
      if (found) {
        fromKey = key;
        card = found;
      }
    });
    if (!card || String(fromKey) === String(id_status_lead)) {
      return;
    }

    const next = { ...columns };
    next[fromKey] = (next[fromKey] || []).filter(
      (item) => Number(item.id_lead) !== Number(id_lead)
    );
    next[id_status_lead] = [...(next[id_status_lead] || []), { ...card, id_status_lead }];
    setColumns(next);

    configAxios
      .post('/leads/updateLead', { id_lead, id_status_lead, id_user_alt: infoState.id })
      .then(() => {
        NotificationManager.success('Status atualizado!', 'Sucesso');
        getKanban();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
        getKanban();
      });
  }

  function onCardDragStart(e) {
    const list = columns[e.fromData] || [];
    e.itemData = list[e.fromIndex];
    draggingRef.current = true;
  }

  function onCardAdd(e) {
    const card = e.itemData;
    if (!card || !card.id_lead) {
      return;
    }
    moveLeadStatus(card.id_lead, e.toData);
  }

  function onCardDragEnd() {
    setTimeout(() => {
      draggingRef.current = false;
    }, 0);
  }

  function HandleCardClick(id_lead) {
    if (draggingRef.current) {
      draggingRef.current = false;
      return;
    }
    getLead(id_lead);
  }

  const totalCards = Object.values(columns).reduce((sum, list) => sum + (list || []).length, 0);

  return (
    <RenderPage title="Leads Kanban">
      <>
        <AddEditLead
          openModal={openModal}
          setOpenModal={setOpenModal}
          infosItemEdit={infosItemEdit}
          functionGrid={getKanban}
        />
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Gestão de Leads
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Acompanhe os leads captados pelo formulário. Arraste o card para trocar o status ou
                clique para abrir o detalhe.
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="outlined"
              onClick={() => getKanban(withScope(filters))}
              disabled={loading}
              startIcon={<Iconify icon="eva:refresh-outline" />}>
              Atualizar
            </Button>
          </Stack>
        </Stack>

        <Card>
          <CustomGrid>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={2}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  type="date"
                  label="Data inicial"
                  InputLabelProps={{ shrink: true }}
                  value={filters.data_de}
                  onChange={(e) => setFilters({ ...filters, data_de: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  type="date"
                  label="Data final"
                  InputLabelProps={{ shrink: true }}
                  value={filters.data_ate}
                  onChange={(e) => setFilters({ ...filters, data_ate: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label="Buscar"
                  value={filters.q}
                  onChange={(e) => setFilters({ ...filters, q: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  variant="outlined"
                  label="Canal"
                  value={filters.id_acquisition}
                  onChange={(e) => setFilters({ ...filters, id_acquisition: e.target.value })}>
                  <MenuItem value="">Todos</MenuItem>
                  {acquisitions.map((a) => (
                    <MenuItem key={a.id_acquisition} value={a.id_acquisition}>
                      {a.canal}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  variant="outlined"
                  label="Temperatura"
                  value={filters.temperatura}
                  onChange={(e) => setFilters({ ...filters, temperatura: e.target.value })}>
                  <MenuItem value="">Todas</MenuItem>
                  <MenuItem value="Quente">Quente</MenuItem>
                  <MenuItem value="Morno">Morno</MenuItem>
                  <MenuItem value="Frio">Frio</MenuItem>
                </TextField>
              </Grid>
              {!isBroker && (
                <Grid item xs={12} md={2}>
                  <Autocomplete
                    options={infosBroker}
                    value={
                      infosBroker.find((item) => String(item.id) === String(filters.id_broker)) ||
                      null
                    }
                    getOptionLabel={(option) => option.label || ''}
                    isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                    onChange={(event, value) => {
                      setFilters({
                        ...filters,
                        id_broker: value ? value.id : '',
                        id_user: ''
                      });
                      loadVendors(value ? value.id : null);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Corretora" size="small" variant="outlined" />
                    )}
                  />
                </Grid>
              )}
              {canSelectVend && (
                <Grid item xs={12} md={2}>
                  <Autocomplete
                    options={infosVend}
                    value={
                      infosVend.find((item) => String(item.id) === String(filters.id_user)) || null
                    }
                    getOptionLabel={(option) => option.label || ''}
                    isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                    onChange={(event, value) =>
                      setFilters({ ...filters, id_user: value ? value.id : '' })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Vendedor"
                        size="small"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              )}
              <Grid item xs={12} md="auto">
                <Stack direction="row" alignItems="center" spacing={1} sx={{ height: '100%' }}>
                  <Button
                    variant="contained"
                    size="medium"
                    color="primary"
                    onClick={() => getKanban(withScope(filters))}
                    disabled={loading}
                    startIcon={<Iconify icon="eva:funnel-outline" />}>
                    Filtrar
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <CustomInfosForm sx={{ mt: 2 }}>
              {totalCards} lead(s) encontrado(s). Arraste o card para trocar o status.
            </CustomInfosForm>
          </CustomGrid>
        </Card>

        <Card sx={{ mt: 2 }}>
          <CustomGrid>
            <Box sx={{ height: 'calc(100vh - 320px)' }}>
              <Scrollbar
                sx={{
                  height: 1,
                  '& .simplebar-content': {
                    height: 1,
                    display: 'flex',
                    gap: 2,
                    alignItems: 'stretch',
                    pb: 1
                  }
                }}>
                {statuses.map((status) => {
                  const cards = columns[status.id_status_lead] || [];
                  const totalValor = cards.reduce(
                    (sum, card) => sum + Number(card.valor_proposta || 0),
                    0
                  );
                  return (
                    <Box
                      key={status.id_status_lead}
                      sx={{
                        width: 260,
                        flex: '0 0 260px',
                        height: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0
                      }}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={1}
                        mb={1}>
                        <Chip
                          size="small"
                          color={
                            status.perdido === 'S'
                              ? 'error'
                              : status.fundo === 'S'
                              ? 'warning'
                              : 'primary'
                          }
                          label={status.status}
                          sx={{ maxWidth: 180 }}
                        />
                        <Typography variant="body2" color="text.secondary">
                          {cards.length}
                        </Typography>
                      </Stack>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Total: {formatCurrencyBRL(totalValor)}
                      </Typography>
                      <Divider sx={{ my: 1.5 }} />

                      <Box
                        sx={{
                          flex: 1,
                          minHeight: 0,
                          height: 0,
                          '& .dx-sortable': { minHeight: 80, width: '100%' },
                          '& .dx-sortable-placeholder': { display: 'none' },
                          '& .lead-kanban-card': {
                            width: '100%',
                            boxSizing: 'border-box'
                          }
                        }}>
                        <Scrollbar
                          sx={{
                            height: 1,
                            '& .simplebar-content': {
                              height: 'auto',
                              display: 'block',
                              pt: 0.5,
                              pr: 1.5,
                              pb: 0.5
                            }
                          }}>
                          <Sortable
                            group="leadsKanban"
                            data={status.id_status_lead}
                            filter=".lead-kanban-card"
                            itemOrientation="vertical"
                            dropFeedbackMode="push"
                            allowReordering={false}
                            onDragStart={onCardDragStart}
                            onAdd={onCardAdd}
                            onDragEnd={onCardDragEnd}>
                            {cards.map((card) => (
                              <Card
                                key={card.id_lead}
                                className="lead-kanban-card"
                                variant="outlined"
                                onClick={() => HandleCardClick(card.id_lead)}
                                sx={{
                                  width: '100%',
                                  textDecoration: 'none',
                                  color: 'inherit',
                                  flexShrink: 0,
                                  cursor: 'grab',
                                  mb: 1.5,
                                  '&:active': { cursor: 'grabbing' }
                                }}>
                                <CustomGrid>
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={0.5}>
                                    <Typography
                                      variant="subtitle2"
                                      title={card.nome || '-'}
                                      noWrap
                                      sx={{
                                        flex: 1,
                                        minWidth: 0,
                                        textTransform: 'uppercase'
                                      }}>
                                      {card.nome || '-'}
                                    </Typography>
                                    <Chip
                                      size="small"
                                      color={
                                        card.temperatura === 'Quente'
                                          ? 'error'
                                          : card.temperatura === 'Morno'
                                          ? 'warning'
                                          : 'info'
                                      }
                                      variant="contained"
                                      label={card.temperatura || '-'}
                                    />
                                  </Stack>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                    noWrap
                                    sx={{ textTransform: 'capitalize' }}>
                                    {card.cidade || '-'}
                                    {card.uf ? `/${card.uf}` : ''}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                    noWrap>
                                    {card.benefs_total || 0} benef.
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                    sx={{ textTransform: 'capitalize' }}>
                                    {card.canal || '-'}
                                  </Typography>
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    flexWrap="nowrap"
                                    sx={{ mt: 0.5, gap: 0.5, minHeight: 20, overflow: 'hidden' }}>
                                    {(card.tags || []).length > 0 ? (
                                      (card.tags || []).map((t) => (
                                        <Chip
                                          key={t.id_tag}
                                          size="small"
                                          label={t.tag}
                                          sx={{
                                            bgcolor: t.cor || undefined,
                                            color: t.cor ? '#fff' : undefined,
                                            height: 20,
                                            fontSize: 11,
                                            flexShrink: 0
                                          }}
                                        />
                                      ))
                                    ) : (
                                      <Chip
                                        size="small"
                                        label="-"
                                        variant="outlined"
                                        sx={{ height: 20, fontSize: 11 }}
                                      />
                                    )}
                                  </Stack>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                    noWrap
                                    fontWeight={700}
                                    sx={{ mt: 0.5 }}>
                                    {tempoNaEtapa(card.data_hora_status_atual)}
                                  </Typography>
                                </CustomGrid>
                              </Card>
                            ))}
                            {!cards.length && (
                              <Typography variant="body2" color="text.secondary" sx={{ pt: 0.5 }}>
                                Nenhum lead neste status
                              </Typography>
                            )}
                          </Sortable>
                        </Scrollbar>
                      </Box>
                    </Box>
                  );
                })}
                {!statuses.length && (
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                    <Typography variant="body2" color="text.secondary">
                      Não há status cadastrados
                    </Typography>
                  </Box>
                )}
              </Scrollbar>
            </Box>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default LeadsKanban;
